import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { LsqListSource } from '@lsq-frontend/angular-shared/api-service';
import { Color, Icons } from '@lsq-frontend/common-ui';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, finalize, switchMap, debounceTime } from 'rxjs/operators';
import { Invoice, StatusInvoiceEnum } from './invoice';
import { InvoiceService } from './invoice.service';

@Component({
    selector: 'app-root',
    templateUrl: './admin-invoices.component.html',
    styleUrls: ['./admin-invoices.component.scss']
})
export class AdminInvoicesComponent implements OnInit {
    public filterOptions: string[];
    public allInvoices = 'All Invoices';
    public filtersFormGroup = new FormGroup({
        invoiceStatusFilter: new FormControl(this.allInvoices),
        invoiceSearch: new FormControl()
    });
    public readonly icons = Icons;
    public readonly color = Color;

    private _loading = new BehaviorSubject<boolean>(false);
    public loading = this._loading.asObservable();
    public getInvoiceRequest$ = new BehaviorSubject<
        Parameters<InvoiceService['getInvoicesWithFilters']>
    >(['', '']);
    public tableDataSource = new LsqListSource<Invoice>({
        rows$: this.getInvoiceRequest$.pipe(
            debounceTime(1000),
            switchMap((args) => this.loadRows(args)),
            map((dataInvoices) => {
                this._loading.next(false);
                return dataInvoices['getInvoices'];
            })
        ) as Observable<any>,
        loading$: this.loading.pipe(map((initialized: boolean) => initialized)),
        handleSort: (sorting) => {
            this.tableDataSource.sortColumn = sorting.sortColumn;
            this.tableDataSource.sortDirection = sorting.sortDirection;
        }
    });

    constructor(private invoiceService: InvoiceService) {}

    ngOnInit(): void {
        this.filterOptions = [this.allInvoices];
        this.filterOptions = [this.allInvoices].concat(
            Object.values(StatusInvoiceEnum) as string[]
        );
    }

    public loadInvoices(searchText: string, statusFilter: string): void {
        this.getInvoiceRequest$.next([searchText, statusFilter]);
    }

    public loadRows([searchText, statusFilter]: string[]): Observable<any> {
        this._loading.next(true);
        return this.invoiceService.getInvoicesWithFilters(searchText, statusFilter).pipe(
            catchError((error) => {
                console.log(error);
                this._loading.next(false);
                return of([]);
            }),
            finalize(() => {
                this._loading.next(false);
            })
        );
    }

    public handleFilterChange(): void {
        let status = this.filtersFormGroup.value.invoiceStatusFilter;
        if (this.filtersFormGroup.value.invoiceStatusFilter === this.allInvoices) {
            status = '';
        }
        const searchText = this.filtersFormGroup.value.invoiceSearch || '';
        this.loadInvoices(searchText, status);
    }
}
